export default function Home() {
  return (
    <div className="p-4">
      <h2>Welcome</h2>
      <p>
        Welcome to Saudi Mais Production System.  
        Please select a module from the menu.
      </p>
    </div>
  );
}
